import { render, staticRenderFns } from "./DiadaPreview.vue?vue&type=template&id=38bb03ca&lang=pug&"
import script from "./DiadaPreview.vue?vue&type=script&lang=js&"
export * from "./DiadaPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports